import React from "react";
import { useParams } from "react-router-dom";
import RequireAuth from "../../components/RequireAuth/RequireAuth";
import { CreateRankingContent } from "../CreateRanking/CreateRanking";

function EditRanking() {
  const { independent_ranking_id } = useParams();

  return (
    <RequireAuth>
      <CreateRankingContent rankingId={independent_ranking_id} />
    </RequireAuth>
  );
}

export default EditRanking;
